<template>
  <div class="container">
    <!--b-card :title="isEntry ? $t('livestock_incoming') : $t('livestock_outgoing')" :class="isRtleft ? 'text-end' : 'text-start'"-->
      <!-- Form Section -->
      <div>
        <form @submit.prevent="saveMovement" class="row g-3 align-items-center justify-content-between">
          <div class="form-group row">
            <!-- Liste of sources -->
            <label v-if="isEntry" for="selectSource" class="col-sm-2 text-start col-form-label">{{ $t('select_source') }}</label>
            <label v-else for="selectDestination" class="col-sm-2 text-start col-form-label">{{ $t('select_destination') }}</label>
                <div class="col-sm-4">
                  
                  <select v-if="isEntry" id="selectSource" v-model="movement.source" class="form-control form-select" :placeholder="$t('select_source')" required>
                    <option v-for="source in sourceOptions" :key="source.id" :value="source">
                      {{ source.value }}
                    </option>
                  </select>

                  <select v-else id="selectDestination" v-model="movement.destination" class="form-control form-select" :placeholder="$t('select_destination')" required>
                    <option v-for="destination in destinationOptions" :key="destination.id" :value="destination">
                      {{ destination.value }}
                    </option>
                  </select>
                </div>
            
            
            
            <!-- Date -->
                  <label for="selectDate" class="col-sm-1 text-start col-form-label">{{ $t('date') }}</label>
                  <div class="col-sm-2">
                    <input id="selectDate" v-model="movement.date" type="date" class="form-control" :placeholder="$t('select_date')" required />
                  </div>
            
            <!-- Number -->
                  <label for="inputNumber" class="col-sm-1 text-start col-form-label">{{ $t('input_number') }}</label>
                  <div class="col-sm-2">
                    <input id="inputNumber" v-model="movement.nombre" type="number" class="form-control" :placeholder="$t('input_number')" required />
                  </div>
          </div>
          <div class="form-group row">
                  <!-- Weight -->
                  <label for="inputWeight" class="col-sm-2 text-start col-form-label">{{ $t('input_weight') }}</label>
                        <div class="col-sm-4">
                          <div class="input-group">
                            <input id="inputWeight" v-model.number="movement.poidTot" type="number" class="form-control" :placeholder="$t('input_weight')" required/>
                            <span class="input-group-text">kg</span>
                          </div>
                        </div>
                  
                  <!-- Calculated Weight Per Unit -->
                  <label for="weightPerUnit" class="col-sm-2 text-start col-form-label">{{ $t('weight_per_unit') }}</label>
                        <div class="col-sm-2">
                          <div class="input-group">
                            <input id="weightPerUnit" type="text" class="form-control" :value="formattedWeightPerUnit" disabled readonly/>
                          <span class="input-group-text">kg/1</span>
                          </div>
                        </div>
                  
          </div>
          <div class="form-group row">
            <!-- Price -->
            <label for="inputPrice" class="col-sm-2 text-start col-form-label">{{ $t('input_price') }}</label>
                        <div class="col-sm-4">
                          <div class="input-group">
                            <input id="inputPrice" v-model.number="movement.prixTot" type="number" class="form-control" :placeholder="$t('input_price')" required />
                          <span class="input-group-text">€</span>
                          </div>
                        </div>
                  <!-- Calculated Price Per Unit -->
                  <label for="pricePerUnit" class="col-sm-2 text-start col-form-label">{{ $t('price_per_unit') }}</label>
                        <div class="col-sm-2">
                          <div class="input-group">
                            <input type="text" id="pricePerUnit" class="form-control" :value="formattedPricePerUnit" disabled readonly/>
                          <span class="input-group-text">€/kg</span>
                          </div>
                        </div>
          </div>
          <!-- Add a new row for Total Price -->
          <div class="form-group row">
            <label for="totalPrice" class="col-sm-2 text-start col-form-label">{{ $t('total_price') }}</label>
            <div class="col-sm-4">
              <div class="input-group">
                <input id="totalPrice" type="text" class="form-control" :value="formattedTotalPrice" disabled readonly/>
                <span class="input-group-text">€</span>
              </div>
            </div>
          </div>
          <div class="form-group row">
                  <!-- Remark -->
                  <label for="inputRemarque" class="col-sm-2 text-start col-form-label">{{ $t('input_remarque') }}</label>
                  <div class="col-12 col-md-10 mt-3">
                    <textarea id="inputRemarque" v-model="movement.remarque" class="form-control" rows="2" :placeholder="$t('input_remarque')"></textarea>
                  </div>
          </div>

          
          
        </form>
      </div>
    <!--/b-card-->
  </div>
</template>

<script>
import { Message } from "../libjs/alertService";

export default {
  props: ["sourceOptions", "destinationOptions", "isEntry", "movementData", "totalExpenses"],
  data() {
    return {
      movement: {
        id: null,
        e_s: null,
        source: null,
        date: null,
        nombre: null,
        poidTot: null,
        prixTot: null,
        remarque: "",
        destination: null,
        operation: 'P'
      },
    };
  },
  computed: {
    isRtleft() {
      return this.$i18n.locale === "ar"; // Adjust based on locale
    },
    pricePerUnit() {
      // Calculate price per unit
      if (this.movement.poidTot && this.movement.prixTot) {
        return this.movement.prixTot / this.movement.poidTot;
      }
      return 0;
    },
    weightPerUnit() {
      // Calculate price per unit
      if (this.movement.poidTot && this.movement.nombre) {
        return this.movement.poidTot / this.movement.nombre;
      }
      return 0;
    },
    formattedPricePerUnit() {
      // Format the result as a fixed decimal value
      return this.pricePerUnit.toFixed(2);
    },
    formattedWeightPerUnit() {
      // Format the result as a fixed decimal value
      return this.weightPerUnit.toFixed(2);
    },
    // Add a computed property for Total Price
    totalPrice() {
      const price = this.movement.prixTot || 0;
      const expenses = this.totalExpenses || 0;
      return price + expenses;
    },
    formattedTotalPrice() {
      return this.totalPrice.toFixed(2); // Format to 2 decimal places
    },
  },
  methods: {
    saveMovement() {
      try {
        if (this.validateForm()) {
          if (this.movement.id) {
            this.$emit("updateMovement", this.movement); // Emit an update event
            Message("success", this.$t("message.update_success"));
          } else {
            this.$emit("addMovement", this.movement); // Emit an add event
            Message("success", this.$t("message.add_success"));
          }
          this.resetForm();
        }
      } catch (error) {
        Message("danger", this.$t("message.operation_failed"));
      }
    },
    resetForm() {
      this.movement = {
        id: null,
        e_s: null,
        source: null,
        date: null,
        nombre: null,
        poidTot: null,
        prixTot: null,
        remarque: "",
        destination: null,
        operation: 'P'
      };
    },
    validateForm() {
      if (
        !this.movement.source ||
        !this.movement.date ||
        !this.movement.nombre ||
        !this.movement.poidTot ||
        !this.movement.prixTot
      ) {
        Message("warning", this.$t("You need to fill all data of form"));
        return false;
      }
      return true;
    },
  },
  mounted() {
    if (Object.keys(this.movementData).length > 0) {
      this.movement = this.movementData
    }    
  }
};
</script>

<style scoped>
/* General Styling */
body, input, button {
  font-family: "Arial", sans-serif;
  font-size: 14px;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}
.input-group-text {
  font-size: 14px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
}

/* Remove arrows in Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

form button {
  font-size: 14px;
  padding: 8px;
  border-radius: 4px;
  border: none;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="reset"] {
  background-color: #6c757d;
  color: #fff;
}

form button:hover {
  opacity: 0.9;
}
</style>
